import React, { useEffect, useState } from "react";
import { Container, Form, Row, Col, Button, Image, Modal, Spinner } from "react-bootstrap";
import { getStyles } from "./ViewProduct.style";
import AddProductImage from "../../assets/images/addProductTitle.png";
import TitleBar from "../../Components/TitleBar/TitleBar";
import Section from "../../Components/Section/Section";
import { Product_Delete, Product_Details } from "../../Api";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { STORAGE_CONSTANTS } from "../../shared/Constants/Constants";
import { useTranslation } from "react-i18next";
import { base_url } from "../../Api/ApiConst";
import Carousel from "react-multi-carousel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { RootState } from "../../Redux/Store/Store";

// components
import DeleteConfirmationModal from "./components/DeleteConfirmationModal";
import ProductCarousel from "./components/ProductCarousel";
import FormGroup from "./components/FormGroup";

const ViewProduct: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const styles = getStyles(isMobile);
  const breadcrumbs = [<Link to="/" key="home">
  {t("footer.home")}
</Link>, "Store"];
  const title: string = t("product.viewProduct");
  const imageUrl: string = AddProductImage;

  const [productType, setProductType] = useState<"single" | "bulk" | "system">(
    "single"
  );
  const [productName, setProductName] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [unitOfMeasure, setUnitOfMeasure] = useState("");
  const [variants, setVariants] = useState("");
  const [brand, setBrand] = useState("");
  const [sku, setSku] = useState("");
  const [minQuantity, setMinQuantity] = useState("");
  const [maxQuantity,setMaxQuantity] = useState("")
  const [inventory, setInventory] = useState("");
  const [price, setPrice] = useState("");
  const [productImage, setProductImage] = useState("");
  const [additional_image_1, setAdditional_image_1] = useState("");
  const [additional_image_2, setAdditional_image_2] = useState("");
  const [productQuantity, setProductQuantity] = useState("");
  const [systemProductID, setSystemProductID] = useState("");
  const [userToken, setUserToken] = useState<string | null>("");
  const [storeId, setStoreId] = useState<string | null>("");
  const [productNameInNepali, setProductNameInNepali] = useState("");
  const [descriptionInNepali, setDescriptionInNepali] = useState("");
  const [priceInNepali, setPriceInNepali] = useState<any>("");
  const [threshold,setThreshold] = useState<any>("");
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;
  const [showDeleteModal, setShowDeleteModal] = useState(false); 
  const [deleting, setDeleting] = useState(false); 

  const { product_id } = state;


  const userLatitude = useSelector(
    (state: RootState) => state.Location.selected_latitude
  );

  const userLongitude = useSelector(
    (state: RootState) => state.Location.selected_longitude
  );
  const userPincode = useSelector((state: RootState) => state.Location.pincode);


  useEffect(() => {
    setUserToken(localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN));
    setStoreId(localStorage.getItem(STORAGE_CONSTANTS.STORE_ID));
    localStorage.setItem(STORAGE_CONSTANTS.PRODUCT_ID, product_id);
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (product_id) {
      fetchStoreList();
    }
  }, [product_id]);

  const fetchStoreList = async () => {
    try {
      const response = await Product_Details(product_id,userLatitude,userLongitude,userPincode);
      if (response && response.status === 200) {
        let data = response.data.product_details;
        setProductName(data.product_name);
        setDescription(data.product_description);
        setUnitOfMeasure(data.unit_measure);
        setMinQuantity(data.minimum_qty);
        setVariants(data.weight);
        setMaxQuantity(data.maximum_qty);
        setSku(data.sku);
        setBrand(data.brand);
        setThreshold(data.threshold_limit) 
        setPrice(data.usd_price);
        setInventory(data.available);
        setCategory(data.product_subcategory.name);
        setProductImage(data.product_image);
        setAdditional_image_1(data.additional_image_1);
        setAdditional_image_2(data.additional_image_2);
        setPriceInNepali(data.price);
        setProductNameInNepali(data?.language_data?.length > 0 ? data.language_data[0]?.product_name:"");
        setDescriptionInNepali(data?.language_data?.length > 0 ? data.language_data[0]?.product_description : "");
      } else {
        console.log("Error fetching Store Product Details");
      }
    } catch (error) {
      console.log("Error fetching Store Product Details", error);
    }
  };

  const handleProductTypeChange = (type: "single" | "bulk" | "system") => {
    setProductType(type);
    // Reset related fields when switching product types
    setProductName("");
    setCategory("");
    setDescription("");
    setUnitOfMeasure("");
    setVariants("");
    setMinQuantity("");
    setInventory("");
    setPrice("");
    setProductQuantity("");
    setSystemProductID("");
    setProductNameInNepali("");
    setDescriptionInNepali("");
    // setPriceInNepali("");
  };

  const handleDelete = async () => {
    setDeleting(true);

    try {
      const response = await Product_Delete(product_id, userToken);
      if (response && response.status === 200) {
        toast.success(response["data"]["message"]);
        setShowDeleteModal(false); // Close modal after deletion
        navigate("/products");
      } else {
        console.log("Error Deleting the product");
      }
    } catch (error) {
      console.log("Error Deleting the product", error);
    } finally {
      // Reset deleting state after the operation
      setDeleting(false);
    }
  };
  const handleShowDeleteModal = () => {
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };


  const handleThumbnailClick = (index: number) => {
    setActiveIndex(index);
  };

  const [activeIndex, setActiveIndex] = useState(0);


  return (
    <div className="viewProduct">
      <TitleBar breadcrumbs={breadcrumbs} title={title} imageUrl={imageUrl} />
      <Section className="addProduct" style={styles.sectionTopMargin}>
        <div style={styles.whiteWrap}>
          <Container>
            <Form>
              <div style={styles.divCenter}>
                
              </div>

              {productType === "single" && (
                <>
                  <FormGroup value={productName} controlId="productName" tValue="product.productName" />
                  <FormGroup value={category} controlId="category" tValue="product.category" />
                  <Form.Group controlId="description">
                    <Form.Label>{t("product.description")}</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={description}
                      readOnly
                    />
                  </Form.Group>

                  <Row className="sm-product-image-row">
                    <Col sm={3}>
                      <ProductCarousel
                        productImage={productImage}
                        additionalImages={[additional_image_1, additional_image_2]}
                        activeIndex={activeIndex}
                        setActiveIndex={setActiveIndex}
                        handleThumbnailClick={handleThumbnailClick} 
                      />
                    </Col>
                    <Col sm={9} className="mt-2">
                    <Row>
                      <FormGroup value={variants} controlId="variations" tValue="product.variations" />
                      <FormGroup value={unitOfMeasure} controlId="unitOfMeasure" tValue="product.unitOfMeasure" />
                    
                      </Row>
                      <Row className="mt-2">
                      <FormGroup value={minQuantity} controlId="minQuantity" tValue="product.minimumQuantity" />
                      <FormGroup value={maxQuantity} controlId="maxQuantity" tValue="product.maximumQuantity" />
                     </Row>
                     <Row className="mt-2">
                      <FormGroup value={brand} controlId="brand" tValue="product.brand" />
                      <FormGroup value={sku} controlId="sku" tValue="product.sku" />

                     </Row>
                     <Row className="mt-2">
                      <FormGroup value={inventory} controlId="inventory" tValue="product.inventory" />
                    <FormGroup value={threshold} controlId="threshold" tValue="Threshold limit" readOnly={true} placeholder="Threshold limit" onChange={(e) => { setThreshold(threshold) }} />
                  {/* </Form.Group> */}
                     </Row>
                    </Col>
                  </Row>
                  <FormGroup value={priceInNepali} controlId="priceInNepali" tValue="product.priceInNepali" readOnly={true} placeholder={t("product.priceInNepali")} onChange={(e) => { setPriceInNepali(e.target.value) }} />
                  <p style={styles.heading}>{t("product.otherLanguage")}</p>
                 
                  <FormGroup value={productNameInNepali} controlId="productNameInNepali" tValue="product.productNameInNepali" readOnly={true} placeholder={t("product.productNameInNepali")} onChange={(e) => { setProductNameInNepali(e.target.value) }} />
                  
                  <FormGroup value={descriptionInNepali} controlId="descriptionInNepali" tValue="product.descriptionInNepali" readOnly={true} placeholder={t("product.descriptionInNepali")} onChange={(e) => { setDescriptionInNepali(e.target.value) }} />
                </>
              )}

              {productType === "bulk" && <></>}

              {productType === "system" && (
                <Form.Group controlId="systemProductID">
                  <Form.Label>System Product ID</Form.Label>
                  <Form.Control
                    type="text"
                    value={systemProductID}
                    onChange={(e) => setSystemProductID(e.target.value)}
                    required
                  />
                </Form.Group>
              )}
              <Row>
                <Col xs={12}>
                  <div style={styles.divCenter}>
                    <Button
                      variant="primary"
                      onClick={handleShowDeleteModal}
                      style={styles.btnRed}
                    >
                      {t("commonHeader.delete")}
                    </Button>
                    <Button variant="primary" style={styles.btnBlue}>
                      <Link
                        to="/edit-product"
                        style={styles.btnLinkStyle}
                      >
                        {t("commonHeader.edit")}
                      </Link>
                    </Button>
                    <Button variant="primary" style={styles.btnCancel}>
                      <Link
                        to="/products"
                        style={{
                          textDecoration: "none",
                          width: "100%",
                          color: "#333",
                          display: "block",
                        }}
                      >
                        {t("commonHeader.cancel")}
                      </Link>
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          </Container>
        </div>
      </Section>
      <DeleteConfirmationModal
        showDeleteModal={showDeleteModal}
        handleCloseDeleteModal={handleCloseDeleteModal}
        handleDelete={handleDelete}
        deleting={deleting}
      />

    </div>
  );
};

export default ViewProduct;
